import { useSetRecoilState, useRecoilCallback, type RecoilState } from 'recoil'
import { dialogFamily, type IDialogState } from '../useDialog/helpers/dialogFamily/dialogFamily'

export type TSetDialogStateHookReturn<T> = (
  open: IDialogState<T>['open'],
  data?: IDialogState<T>['data'] | null,
) => void

export const useSetDialogState = <T>(id: string): TSetDialogStateHookReturn<T> => {
  const recoilValue = dialogFamily(id) as unknown as RecoilState<IDialogState<T>>
  const setDialog = useSetRecoilState(recoilValue)

  return useRecoilCallback(
    ({ snapshot }) =>
      (open, data) => {
        const state = snapshot.getLoadable(recoilValue).getValue()

        setDialog({ open, data: data === null ? undefined : data ?? state.data })
      },
    [id],
  )
}
